export class ClerkFilter {
    public IncludeInactive?: boolean;
}

export default ClerkFilter;